import React, { useEffect, useRef, useState } from 'react'
import * as image from "../../../src/resources/images";
import { getCapitalized, getChildrenSort, getName, getProfileName, getToolTip, textTrim } from '../../utils/helper';
import { useDispatch, useSelector } from 'react-redux';
import UploadPhoto from '../profile/UploadPhoto';
import AddChild from './AddChild';
import { NavLink, Spinner } from 'react-bootstrap';
import { PATHS } from '../../utils';
import { getSctNotificationCount, getSettingData, logoutAction, sctNotificationDetail } from '../../redux/actions/APIs';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { parentLoginAction, resetStripePlans, selectedUser, showModal } from '../../redux/actions';
import { feedbackDataPostAPI } from '../../redux/actions/FeedbackAPIs';
import UserPinPopUp from '../userprofile/UserPinPopUp';
import AddLearner from '../userprofile/AddLearner';
import SctNotification from './SctNotification';
const NewTopbar = () => {
	const dispatch = useDispatch();
	const history = useHistory();
	const myRef = useRef();
	const {
		alluserdetails,
		loggedInUser,
		defaultChildData,
		breadcrumbData,
		verifyPinResponse,
		parentVerifyResp,
		knowladge_check_response,
		sctReflectionResp,
	} = useSelector((state) => state.collections);

	const [myUserData, setMyUserData] = useState();
	const [showChild, setShowChild] = useState(false);


	const gotoLoginPage = () => {
		history.push(PATHS.CREATELGOIN_STR + loggedInUser.id);
	}

	const handleChangePaswd = () => {
		history.push(PATHS.CHANGEPASSWORD_STR + loggedInUser.id);
	}

	const showNotification = ()=>{
		dispatch(getSctNotificationCount(loggedInUser?.id, defaultChildData?.id));
		dispatch(sctNotificationDetail(loggedInUser?.id, defaultChildData?.id));
	}

	useEffect(()=>{
		if(loggedInUser?.id && defaultChildData?.id){ //	&& sctReflectionResp
				showNotification();
		}
	},[defaultChildData, sctReflectionResp])

	useEffect(()=>{
		if(knowladge_check_response?.records?.length > 0 && knowladge_check_response?.records[0]?.isActivityCompleted){
			showNotification()
		}
	},[knowladge_check_response])



	const ParentRedirectForm = (type, userData) => {
		if (type == "personalDetails") {
			dispatch(selectedUser({ ...userData }));
			history.push({
				pathname: PATHS.BASICDETAILS_STR + userData?.id,
			});
		}
	}

	// console.log("ParentRedirectForm  : ",defaultChildData, loggedInUser, alluserdetails);

	const handleSetting = () => {
		let userId = defaultChildData?.id;
		let levelId = defaultChildData?.level?.id;
		dispatch(parentLoginAction("verifyUser"));
		dispatch(getSettingData(userId, levelId));
		// dispatch(openSetting(true));
	};

	const handlePopUp = (value) => {
		if (value === "isSubscribeNow") {
			dispatch(resetStripePlans());
		}
		if (value === "upgrade") {
			dispatch(showModal({ type: "Subscription", isDiscount: true }));
		} else {
			dispatch(showModal({ type: "Subscription" }));
		}
	};

	const showLockerScreen = (value, childData) => {
		dispatch(showModal({ type: value, childData: childData }));
	}

	const handleInvite = (type) => {
		dispatch(showModal({ type: type }));
	};

	const openModal = () => {
		e.stopPropagation();
		dispatch(showModal({ type: "feedback" }));
		dispatch(feedbackDataPostAPI());
	};
	const [openProfile, setOpenProfile] = useState(false);
	const [openChildProfile, setOpenChildProfile] = useState(false);
	const [childId, setChildId] = useState("");
	const [childData, setChildData] = useState("");

	// const profileHandler = (type) => {
	// 	setOpenChildProfile(false);
	// 	setChildId("");
	// 	// dispatch(getAccordian(accordianSetail));
	// 	// dispatch(getprofile(accordianSetail));
	// 	if (type === "open") {
	// 		setOpenProfile(true);
	// 	} else if (type === "close") {
	// 		setOpenProfile(false);
	// 	}
	// };


	const childProfileHandler = (type, data) => {
		setOpenProfile(false);
		setChildId(data?.id);
		setChildData(data);
		if (data?.id === childId && openChildProfile === true) {
			setOpenChildProfile(false);
		} else if (type === "open") {
			setOpenChildProfile(true);
		} else if (type === "close") {
			setOpenChildProfile(false);
		}
	};

	const editChild = (id, data, url) => {
		history.push({
			pathname: url,
			// state: { edit: true },
		});
	}

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (myRef && myRef.current && myRef.current.contains(event.target)) {
				console.log("handleClik Insise");
			} else {
				console.log("handleClik outSide");
				childProfileHandler("close");
			}
		};
		document.addEventListener("click", handleClickOutside);
		return () => {
			document.removeEventListener("click", handleClickOutside);
		};
	}, []);

	const handleProfile = (url) => {
		dispatch(selectedUser({ ...loggedInUser }));
		history.push({
			pathname: url,
		});
	}

	const handleUserPinPopUp = (dataObj) => {
		if (dataObj) {
			if (!dataObj?.isProfilePin) {
				dataObj.isPin = false;
				dispatch(parentLoginAction(true));
			} else {
				dataObj.isPin = true;
			}
		}

		setMyUserData(dataObj);
		// console.log("handleUserPinPopUp : ", dataObj);

	}

	const handleUserProfile = (userData, isShowPopUp) => {
		if (userData?.role?.name === "PARENT" && isShowPopUp) {
			handleUserPinPopUp(userData);
		}
		else if (["PARENT", "LEARNER"]?.includes(userData?.role?.name)) {
			let access = localStorage.getItem("access_token");
			let tokenData = access.split("##");
			//	console.log("subMitPin : ", tokenData, userData?.id, alluserdetails);
			localStorage.setItem("access_token", tokenData[0] + "##" + userData.id,);
			if (userData?.isUserPlan) {
				window.location.href = PATHS.MYPLAN_PAGE;
			} else {
				window.location.href = PATHS.COURSE_CATLOG_STR + userData?.id;
			}
		}
	}

	useEffect(() => {
		console.log("verifyPinResponse : ", verifyPinResponse, parentVerifyResp);
		if ((parentVerifyResp && parentVerifyResp?.success) || (verifyPinResponse?.records?.length > 0 && verifyPinResponse?.records[0]?.userId)) {
			handleUserProfile(myUserData, false);
			console.log("verifyPinResponse@@ : ", verifyPinResponse, parentVerifyResp)
		}
	}, [verifyPinResponse, parentVerifyResp]);


	const handleChild = (type) => {
		setShowChild(type);
	}



	return (
		<>
			<div className='palteformHeader RootContent menuList '>
				<div className='PFhederitmlist flexone'>
					<div className='mainTitle'>
						<h1>{breadcrumbData?.title}</h1>
					</div>
					<div className='position-relative m-0 flexone'>
						<SctNotification/>
						<div className='dropdown clModal'>
							<span
								className="nav-link dropdown-toggle  My_Profile"
								data-toggle="modal"
								data-target="#ProfileMenuPopup"
								data-bs-toggle="modal"
								data-bs-auto-close="false"
								aria-expanded="false"
							// onClick={() => {
							// 	dispatch(showModal());
							// 	profileHandler("close");
							// }}
							>
								{
									loggedInUser?.role?.name === "PARENT" ? (
										<p className='p1 '>
											{loggedInUser?.imageUrl ? (
												<span>
													<img src={loggedInUser?.imageUrl} className='mr-3' />
												</span>
											) : (
												<span className='user_initials mr-3'>
													{getProfileName(loggedInUser)}
												</span>
											)}
											<span className='user_nametxt'>{getCapitalized(getName(loggedInUser))} <i class="fa-regular fa-angle-down ml-3"></i></span>
										</p>
									) : (
										<p className='p1 '>
											{defaultChildData?.imageUrl ? (
												<span>
													<img src={defaultChildData?.imageUrl} className='mr-3' />
												</span>
											) : (
												<span className='user_initials mr-3'>
													{getProfileName(defaultChildData)}
												</span>
											)}
											<span className='user_nametxt'>{getCapitalized(getName(defaultChildData))} <i class="fa-regular fa-angle-down ml-3"></i></span>
										</p>
									)
								}
							</span>
							{
								true && (
									<div className="ProfileMenuPopup">
										<div
											className="modal fade"
											id="ProfileMenuPopup"
											role="dialog"
											backdrop="static"
										>
											<div className="modal-dialog modal-lg">
												<div className="modal-content ProfilepopupWidth">
													<div className="modal-body Subject_Curriculam p-0 border-0">
														<div className="PProfilePoup p-3">
															<div className="PpUser">
																<div className='flextwo pb-3 pProfilemenus'>
																	<div className="PProimage mr-2">
																		<UploadPhoto topbarSelect={true} showShimmer={true} />
																	</div>
																	<span
																		className="editPProIcon active pointer"
																		onClick={() => {
																			handleProfile(PATHS.BASICDETAILS_STR + loggedInUser?.id)
																			// loggedInUser?.username
																			// 	? handleProfile(PATHS.BASICDETAILS_STR + loggedInUser?.id)
																			// 	: handleProfile(PATHS.CREATELGOIN_STR + loggedInUser?.id)

																		}}
																	>
																		{/* <i className="fa-light fa-pencil"></i> */}

																		<i class="fa-light fa-pen active"></i>
																	</span>

																	<div className="PPUserRInfo">
																		{getName(loggedInUser)?.length > 26 ? (
																			<div id={getName(loggedInUser)}>
																				{getToolTip(
																					getCapitalized(
																						getName(loggedInUser),
																						25
																					)
																				)}
																			</div>
																		) : (
																			""
																		)}
																		<h4 className='fw-600 text-left flexthree flex-wrap'
																			data-for={getName(loggedInUser)}
																			data-event-off=""
																			data-tip
																		>
																			{textTrim(
																				getCapitalized(
																					getName(loggedInUser),
																					25
																				)
																			)}
																			{!loggedInUser?.isActive ? (
																				<p className="verify_usertxt p3 ml-2" onClick={() => varifyEmail(alluserdetails?.records[0]?.username)}>
																					<a href="#" className=''>(Verify Now)</a>
																				</p>
																			) : (
																				<p className="verified_usertxt text-left">(Verified)</p>
																			)}
																		</h4>
																		<p className='p2 lighttextcolor text-left'>
																			{textTrim(loggedInUser?.username, 35) &&
																				textTrim(loggedInUser?.username, 35)}
																		</p>

																	</div>
																</div>
																<div className="OtherCProfile" ref={myRef}>
																	{["PARENT", "TEACHER"]?.includes(loggedInUser?.role?.name) && (
																		<h5
																			className="flex mb-3 mt-3"
																			style={{ cursor: "auto" }}
																		>
																			<span>
																				{/* <img
																					src={image.learnerProfiles}
																					alt=""
																				/>{" "} */}
																				{loggedInUser?.role?.name === "PARENT" ? "Learner " : "Student "}
																				{/* Profile{" "} */}
																			</span>
																		</h5>
																	)}
																	{loggedInUser?.children?.length > 0 &&
																		getChildrenSort(loggedInUser)?.map((child, index) => (
																			<div
																				className={`OtherChPPLstitm pb-4 ${child.id == childId
																					? "activepchild"
																					: ""
																					}`}
																				key={index}
																			>
																				<div className="OchPPlisting flexone"
																					onClick={() => {
																						childProfileHandler(
																							"open",
																							child
																						);
																					}}
																				>
																					<div className="OchpListimg">
																						{child?.imageUrl ? (
																							<img
																								className="rounded-circle"
																								src={child?.imageUrl}
																								alt="..."
																							/>
																						) : (
																							<span className="ProfileChild">
																								{getProfileName(child)}
																							</span>
																						)}
																					</div>
																					<div className="OchpListdtl w-100">
																						<span className="flex">
																							<span className="tooltip1">
																								{index == 0 && loggedInUser?.role?.name === "TEACHER" ? (
																									child?.firstName + " " + child?.lastName
																								) : child?.firstName ? (
																									getCapitalized(
																										textTrim(
																											getName(child)
																										)
																									)
																								) : (
																									<Spinner />
																								)}
																							</span>

																							<span
																							// onClick={() =>
																							// 	editChild(child.id, child)
																							// }
																							>
																								{/* <i className="fa-solid fa-chevron-right"></i> */}
																							</span>
																						</span>
																					</div>
																				</div>
																				{openChildProfile && (
																					<div className="Prifg childpersonalprofile">
																						<ul>
																							<li className="gotochildprofile">
																								<span
																									className="selectedActive d-flex"
																									onClick={() =>
																										handleUserProfile(
																											childData
																										)
																									}
																								>
																									<i className="fa-solid fa-circle-user mr-2"></i>
																									Go to{" "}
																									{getCapitalized(
																										childData?.firstName
																									)}
																									's Profile
																								</span>
																							</li>
																							<li
																								onClick={() => showLockerScreen("MyLockerScreen", childData)}
																							>
																								<span
																									activeclassname="selectedActive"
																								// to={
																								//   PATHS.BASICDETAILS_STR +
																								//   childId
																								// }
																								>
																									<img
																										src={image.mylocker}
																										alt=""
																									/>{" "}
																									My Locker
																								</span>
																							</li>
																							<li
																								// onClick={() =>
																								// 	editChild(
																								// 		childData.id,
																								// 		data,
																								// 		PATHS.BASICDETAILS_STR +
																								// 		childId
																								// 	)
																								// }
																								onClick={() => {
																									ParentRedirectForm(
																										"personalDetails",
																										childData
																									);
																								}}
																							>
																								<span
																									activeclassname="selectedActive"
																								// to={
																								//   PATHS.BASICDETAILS_STR +
																								//   childId
																								// }
																								>
																									<img
																										src={image.notebook}
																										alt=""
																									/>{" "}
																									Personal Details
																								</span>
																							</li>
																							{/* {
																																																loggedInUser?.role?.name !== "TEACHER" && (
																																																	<li
																																																		onClick={() =>
																																																			editChild(
																																																				childData.id,
																																																				data,
																																																				PATHS.INTERESTS_STR +
																																																				childId
																																																			)
																																																		}
																																																	>
																																																		<span
																																																			activeclassname="selectedActive"
																																																		// to={
																																																		//   PATHS.INTERESTS_STR +
																																																		//   childId
																																																		// }
																																																		>
																																																			<img
																																																				src={image.invite_parents_icon}
																																																				alt=""
																																																			/>{" "}
																																																			Invite a Parent
																																																		</span>
																																																	</li>
																																																)
																																															} */}

																							{childData?.username ===
																								"" ||
																								childData?.username ===
																								null ? (
																								<li
																									// onClick={() =>
																									// 	editChild(
																									// 		childData.id,
																									// 		data,
																									// 		PATHS.CREATELGOIN_STR +
																									// 		childId
																									// 	)
																									// }
																									onClick={() => handleProfile(PATHS.CREATELGOIN_STR + childId)}
																								>
																									<span
																										activeclassname="selectedActive"
																									// to={
																									//   PATHS.CREATELGOIN_STR +
																									//   childId
																									// }
																									>
																										<img
																											src={image.login}
																											alt=""
																										/>{" "}
																										Create Login
																									</span>
																								</li>
																							) : (
																								<li
																									onClick={() =>
																										editChild(
																											childData.id,
																											data,
																											PATHS.CHANGEPASSWORD_STR +
																											childId
																										)
																									}
																								>
																									<span className='OchpListimg'
																										activeclassname="selectedActive"
																									// to={
																									//   PATHS.CHANGEPASSWORD_STR +
																									//   childId
																									// }
																									>
																										<span className="ProfileChild">
																											<i className="fa-solid fa-key"></i>
																										</span>{" "}
																										Change Password
																									</span>
																								</li>
																							)}
																							{
																								loggedInUser?.role?.name !== "TEACHER" && false && (
																									<li
																										onClick={() =>
																											editChild(
																												childData.id,
																												data,
																												PATHS.SCHOOLINFO_STR +
																												childId
																											)
																										}
																									>
																										<span
																											activeclassname="selectedActive"
																										// to={
																										//   PATHS.SCHOOLINFO_STR +
																										//   childId
																										// }
																										>
																											<img
																												src={image.enrichment}
																												alt=""
																											/>{" "}
																											School
																										</span>
																									</li>
																								)
																							}
																							{
																								loggedInUser?.role?.name !== "TEACHER" && false && (<li
																									onClick={() =>
																										editChild(
																											childData.id,
																											data,
																											PATHS.ENRICHMENTINFO_STR +
																											childId
																										)
																									}
																								>
																									<span
																										activeclassname="selectedActive"
																									// to={
																									//   PATHS.ENRICHMENTINFO_STR +
																									//   childId
																									// }
																									>
																										<img
																											src={
																												image.enrichmentIcon
																											}
																											alt=""
																										/>{" "}
																										Enrichment
																									</span>
																								</li>)
																							}
																							{
																								loggedInUser?.role?.name !== "TEACHER" && false && (
																									<li
																										onClick={() =>
																											editChild(
																												childData.id,
																												data,
																												PATHS.INTERESTS_STR +
																												childId
																											)
																										}
																									>
																										<span
																											activeclassname="selectedActive"
																										// to={
																										//   PATHS.INTERESTS_STR +
																										//   childId
																										// }
																										>
																											<img
																												src={image.addintresr}
																												alt=""
																											/>{" "}
																											Interests
																										</span>
																									</li>
																								)}

																							{/* <li
																																	  onClick={() =>
																																		handleCloseSKillPopup(
																																		  childData
																																		)
																																	  }
																																	>
																																	  <span activeclassname="selectedActive">
																																		<img
																																		  src={
																																			image.compassicon
																																		  }
																																		  alt=""
																																		/>{" "}
																																		Learner Journey
																																	  </span>
																																	</li> */}
																							{
																								loggedInUser?.role?.name !== "TEACHER" && false && (
																									<li
																										onClick={() =>
																											editChild(
																												childData.id,
																												data,
																												PATHS.PROFILEPERSONALITY_STR +
																												childId
																											)
																										}
																									>
																										<span
																											activeclassname="selectedActive"
																										// to={
																										//   PATHS.PROFILEPERSONALITY_STR +
																										//   childId
																										// }
																										>
																											<img
																												src={
																													image.bussinessdiagram
																												}
																												alt=""
																											/>{" "}
																											Personality Type
																										</span>
																									</li>
																								)
																							}

																							{(loggedInUser?.role?.name === "TEACHER" || loggedInUser?.role?.name === "Student") && (
																								<li
																									onClick={() =>
																										editChild(
																											childData.id,
																											data,
																											PATHS.SKILLSACQUISITION_STR +
																											childId
																										)
																									}
																								>
																									<span activeclassname="selectedActive">
																										<img
																											src={
																												image.acquisitionsurvey
																											}
																											alt=""
																										/>{" "}
																										Skills Acquisition
																									</span>
																								</li>
																							)
																							}
																							{/* <li
																								onClick={() =>
																									editChild(
																										childData.id,
																										data,
																										PATHS.PROFILESMARTQUIZ_STR +
																										childId
																									)
																								}
																							>
																								<span activeclassname="selectedActive">
																									<img
																										src={
																											image.multipleintellQuiz
																										}
																										alt=""
																									/>{" "}
																									Multiple Intelligences
																								</span>
																							</li>
																							<li
																								onClick={() =>
																									editChild(
																										childData.id,
																										data,
																										PATHS.EMPATHYQUIZ_STR +
																										childId
																									)
																								}
																							>
																								<span activeclassname="selectedActive">
																									<img
																										src={
																											image.empathyicon
																										}
																										alt=""
																									/>{" "}
																									Empathy Check
																								</span>
																							</li> */}
																						</ul>
																					</div>
																				)}
																				{/* {openChildProfile && (
																			<div className="Prifg childpersonalprofile">
																				<ul>
																																															</ul>
																			</div>
																		)} */}
																			</div>
																		))}
																	{loggedInUser?.parent && (
																		<div className="OtherChPPLstitm pt-3">
																			<div className="OchPPlisting flexone"
																				onClick={() =>
																					handleUserProfile(
																						loggedInUser?.parent,
																						true
																					)
																				}>
																				<div className="OchpListimg">
																					{loggedInUser?.parent
																						?.imageUrl ? (
																						<img
																							className="rounded-circle"
																							src={
																								loggedInUser?.parent
																									?.imageUrl
																							}
																							alt="..."
																						/>
																					) : (
																						<span
																							className="ProfileChild"
																						>
																							{getProfileName(
																								loggedInUser?.parent
																							)}
																						</span>
																					)}
																				</div>
																				<div
																					className="OchpListdtl w-100"
																				>
																					<p className="flex">
																						<span>
																							{loggedInUser?.parent
																								?.firstName ? (
																								getCapitalized(
																									getName(
																										loggedInUser?.parent
																									)
																								)
																							) : (
																								<Spinner />
																							)}
																						</span>
																					</p>
																				</div>
																			</div>
																		</div>
																	)}
																	{loggedInUser?.role?.name ===
																		"PARENT" && (
																			<div className=" pointer" onClick={() => handleChild(true)}>
																				<p className="p2  addnewlwaernwe w-100">
																					<i class="fa-solid fa-circle-plus mr-2"></i> Add Learner
																				</p>

																			</div>
																		)}
																</div>

																<div className="PPuserDtl OtherCProfile">
																	<h5 className="flex  mt-3 mb-3" style={{ cursor: "auto" }}	>
																		<span>
																			My Account
																		</span>
																	</h5>

																	<div className="PPUserprofile dropdown-toggle">
																		<>
																			{["PARENT", "LEARNER"]?.includes(loggedInUser?.role?.name) && (
																				<>
																					{/* <h4
																				className="flex pointer"
																				onClick={() => {
																					ParentRedirectForm(
																						"personalDetails",
																						loggedInUser
																					);
																				}}
																			>
																				<span className="flex link active">
																					{" "}
																					<img
																						className=""
																						src={image.bar_menu}
																						alt=""
																					/>{" "}
																					My Profile{" "}
																				</span>
																			 <span>
																			<i className="fa-solid fa-chevron-right"></i>
																		</span>{" "} 
																			</h4> */}
																				{loggedInUser?.role?.name === "LEARNER" && (
																					<p
																						className="flex pointer p2 mt-3 mb-3"
																						onClick={() => showLockerScreen("MyLockerScreen", loggedInUser)}
																					>
																						<span className="flex link active">
																							{" "}
																							<img
																								className="mr-2"
																								src={image.mylocker}
																								alt=""
																							/>{" "}
																							My Locker
																						</span>
																					</p>
																				)}	
																				</>


																			)}
																			{loggedInUser?.role?.name === "PARENT" && (
																				<>
																					<p
																						className="p2 mb-4 flex w-100 active pointer"
																						onClick={() => handleSetting()}
																					>
																						<span className="active">
																							<img
																								src={image.Settingicon}
																								className='mr-2'
																								alt=""
																							/>{" "}
																							Settings
																						</span>
																					</p>
																					<p
																						className="p2 mb-4 flex w-100 active pointer"
																						onClick={() => handlePopUp("isSubscribeNow")}
																					>
																						<span className="active">
																							<img
																								src={image.subscription}
																								alt=""
																								className='mr-2'
																							/>{" "}
																							Subscribe
																						</span>
																					</p>
																					{/* <h5

																					className=" flex active pointer"
																					onClick={() => showLockerScreen("MyLockerScreen", defaultChildData)}
																				>
																					<span className="active"
																					>
																						<img
																							src={image.mylocker}
																							alt=""
																						/>{" "}
																						My Locker
																					</span>
																				</h5> */}
																					<p
																						className="p2 mb-4 flex w-100 active pointer"
																						onClick={() => handleInvite("InviteParent")}
																					>
																						<span className="active">
																							<img
																								src={image.inviteparents}
																								alt=""
																								className="active mr-2"
																							/>{" "}
																							Invite a Parent
																						</span>
																					</p>
																					<p
																						className="p2 mb-4 w-100 flex active pointer"
																						onClick={() => handleInvite("Invite")}
																					>
																						<span className="active">
																							<img
																								src={image.invitefriend}
																								alt=""
																								className="active mr-2"
																							/>{" "}
																							Invite a Friend
																						</span>
																					</p>
																					<div className="">
																						{loggedInUser?.username === "" ||
																							loggedInUser?.username === null ? (
																							<div
																								className=" text-left"
																								title="Create Login"
																								onClick={() => gotoLoginPage()}
																							>
																								<p
																									className="d-flex align-items-center p2 mb-4 w-100 flex active pointer">
																									<span className="ProSettng">
																										<i className="fa-solid fa-key mr-2"></i>
																									</span>
																									Create Login
																								</p>
																							</div>
																						) : (
																							<div
																								className=""
																								title="Change Password"
																								onClick={() => handleChangePaswd()}
																							>
																								<p className="d-flex align-items-center p2 mb-4 w-100 flex active pointer OchpListimg">
																									<span className="ProfileChild">
																										<i className="fa-solid fa-key "></i>
																									</span>
																									Change Password
																								</p>
																							</div>
																						)}
																											{/* <div
																							className=" pointer"
																							onClick={() =>
																								dispatch(
																									logoutAction(alluserdetails)
																								)
																							}
																						>
																							<span
																								title="Sign Out"
																								className=""
																							>
																								<i className="fa-solid fa-arrow-right-from-bracket"></i>
																							</span>
																							Sign out
																						</div>  */}
																					</div>
																					

																					{/* <h5
																					className=" flex active pointer"
																					onClick={openModal}
																				>
																					<span className="active">
																						<img
																							src={image.feedbackicon}
																							alt=""
																							className="active"
																						/>{" "}
																						Feedback
																					</span>
																				</h5> */}
																				</>
																			)}
																			<p
																						className="p2 mb-0 w-100 flex active pointer"
																						onClick={() =>
																							dispatch(
																								logoutAction(alluserdetails)
																							)
																						}
																					>
																						<span className="active logouttxt">
																							<img
																								src={image.Sign_out}
																								alt=""
																								className="active mr-2"
																							/>{" "}
																							Logout
																						</span>
																					</p>
																		</>
																	</div>


																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								)
							}
						</div>
					</div>
				</div>
			</div>
			{myUserData && myUserData?.isPin && (
				<UserPinPopUp handleUserPinPopUp={handleUserPinPopUp}
					userData={myUserData}
				/>
			)}
			{showChild && (
				<AddLearner handleChild={handleChild} />
			)}
		</>
	)
}

export default NewTopbar